// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Search-module-closeButton {
  display: none;
}

#Search-module-input {
  display: none;
  height: 100%;
}

#Search-module-inputContainer {
  width: 100%;
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 15px;
}

.Search-module-open #Search-module-closeButton {
  display: flex;
  background-color: transparent;
  color: var(--text);
  width: 24px;
  height: 24px;
  padding: 0;
}

.Search-module-open #Search-module-input {
  display: flex;
  flex-grow: 1;
}

.Search-module-open #Search-module-searchButton {
  display: none;
}

.Search-module-open #Search-module-resultContainer {
  display: flex;
}

#Search-module-resultContainer {
  position: fixed;
  background-color: var(--background);
  box-shadow: var(--box-shadow-default);
  border-radius: 5px;
  padding: 5px;
  margin-top: 45px;
  width: calc(100% - 30px);
  border: 1px solid var(--border);
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  gap: 5px;
  max-height: 500px;
  overflow-y: auto;
}

#Search-module-resultContainer h1 {
  font-size: 14px;
  color: var(--text);
  padding: 0 20px;
}

#Search-module-resultContainer > section {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

#Search-module-resultContainer > section:not(:first-of-type) {
  border-top: 1px solid var(--border);
}

#Search-module-resultContainer > section > h1 {
  padding-top: 10px;
}

#Search-module-resultContainer ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#Search-module-resultContainer button {
  width: 100%;
  text-align: left;
  align-items: center;
  display: flex;
  background-color: var(--background);
  color: var(--text);
  gap: 10px;
  border-radius: 5px;
}

#Search-module-resultContainer button:hover {
  box-shadow: var(--box-shadow-default);
}

#Search-module-searchButton {
  width: 35px;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 100%;
  height: 35px;
  display: flex;
}

@media screen and (min-width: 720px) {

  #Search-module-input {
    display: flex;
    max-width: 500px;
  }

  #Search-module-resultContainer {
    display: flex;
    max-width: 500px;
  }

  .Search-module-open #Search-module-closeButton, #Search-module-searchButton {
    display: none;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Search/Search.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":["#closeButton {\n  display: none;\n}\n\n#input {\n  display: none;\n  height: 100%;\n}\n\n#inputContainer {\n  width: 100%;\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  gap: 15px;\n}\n\n.open #closeButton {\n  display: flex;\n  background-color: transparent;\n  color: var(--text);\n  width: 24px;\n  height: 24px;\n  padding: 0;\n}\n\n.open #input {\n  display: flex;\n  flex-grow: 1;\n}\n\n.open #searchButton {\n  display: none;\n}\n\n.open #resultContainer {\n  display: flex;\n}\n\n#resultContainer {\n  position: fixed;\n  background-color: var(--background);\n  box-shadow: var(--box-shadow-default);\n  border-radius: 5px;\n  padding: 5px;\n  margin-top: 45px;\n  width: calc(100% - 30px);\n  border: 1px solid var(--border);\n  box-sizing: border-box;\n  display: none;\n  flex-direction: column;\n  gap: 5px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n#resultContainer h1 {\n  font-size: 14px;\n  color: var(--text);\n  padding: 0 20px;\n}\n\n#resultContainer > section {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n#resultContainer > section:not(:first-of-type) {\n  border-top: 1px solid var(--border);\n}\n\n#resultContainer > section > h1 {\n  padding-top: 10px;\n}\n\n#resultContainer ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n#resultContainer button {\n  width: 100%;\n  text-align: left;\n  align-items: center;\n  display: flex;\n  background-color: var(--background);\n  color: var(--text);\n  gap: 10px;\n  border-radius: 5px;\n}\n\n#resultContainer button:hover {\n  box-shadow: var(--box-shadow-default);\n}\n\n#searchButton {\n  width: 35px;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  border-radius: 100%;\n  height: 35px;\n  display: flex;\n}\n\n@media screen and (min-width: 720px) {\n\n  #input {\n    display: flex;\n    max-width: 500px;\n  }\n\n  #resultContainer {\n    display: flex;\n    max-width: 500px;\n  }\n\n  .open #closeButton, #searchButton {\n    display: none;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `Search-module-closeButton`,
	"input": `Search-module-input`,
	"inputContainer": `Search-module-inputContainer`,
	"open": `Search-module-open`,
	"searchButton": `Search-module-searchButton`,
	"resultContainer": `Search-module-resultContainer`
};
export default ___CSS_LOADER_EXPORT___;
